export const GLOBAL_NAVIGATION = 'Global.Navigation';
export const MOONSHOT_OUTAGE_FLAG = 'Moonshot.Outage';
export const PB_MOONSHOT_FLAG = 'PB.Moonshot';
export const PB_MULTI_SITE_FLAG = 'PB.multisite-billing';
export const PURCHASE_LICENSE_FLOW_FLAG = 'PlatformAdmin.PurchaseLicenseFlow';
export const BULK_IMPORTS = 'PlatformAdmin.BulkImports.Rearchitecture';
